import React, { Component } from 'react'
import Paper from 'material-ui/Paper'
import PaperHeader from '../components/PaperHeader'
import RiskList from '../components/RiskList'
import { pageLoaded } from './utils'

export default class RiskRegister extends Component {
  componentDidMount() {
    pageLoaded('Risk Register')
  }

  render() {
    return (
      <Paper zDepth={2}>
        <PaperHeader title='Risk Register' />
        {<RiskList {...this.props} />}
      </Paper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/RiskRegister.js